import React from 'react'
import { styled, createTheme } from './stitches.config'

const StyledThemeProvider = styled('div', {})

type Props = {
  children: React.ReactNode
}

const DynamicThemeProvider: React.FC<Props> = ({ children }) => {
  // const primaryVariants = createHSLVariants('')
  // const backgroundVariants = createHSLVariants('')

  const dynamicTheme = React.useMemo(
    () =>
      createTheme({
        colors: {
          // primary25: primaryVariants?.[11] || '#E6F6FF',
          // primary50: primaryVariants?.[10] || '#D4EFFE',
          // primary100: primaryVariants?.[9] || '#AAE1FF',
          // primary200: primaryVariants?.[8] || '#80D2FF',
          // primary300: primaryVariants?.[7] || '#55C2FF',
          // primary400: primaryVariants?.[6] || '#2AB3FF',
          // primary500: primaryVariants?.[5] || '#1CAEFF',
          // primary600: primaryVariants?.[4] || '#01A4FE',
          // primary700: primaryVariants?.[3] || '#0074DD',
          // primary800: primaryVariants?.[2] || '#005280',
          // primary900: primaryVariants?.[1] || '#003755',
          // primary950: primaryVariants?.[0] || '#001B2A',
          // gray300: backgroundVariants?.[7] || '#D0D5DD',
          // // Update these with dynamic values
          // primaryBase: primaryVariants?.[5] || '#1CAEFF',
          // primaryBgSubtle: primaryVariants?.[1] || '#003755',
          // primaryLine: primaryVariants?.[5] || '#1CAEFF',
          // primaryBg: primaryVariants?.[5] || '#1CAEFF',
          // primaryBgLight: primaryVariants?.[10] || '#D4EFFE',
          // primaryBgHover: primaryVariants?.[4] || '#01A4FE',
          // primaryBgActive: primaryVariants?.[5] || '#1CAEFF',
          // primaryBorder: primaryVariants?.[8] || '#80D2FF',
          // primaryBorderFocus: primaryVariants?.[5] || '#1CAEFF',
          // primaryBorderHover: primaryVariants?.[7] || '#55C2FF',
          // primaryDisabled: primaryVariants?.[8] || '#80D2FF',
          // primarySolid: primaryVariants?.[5] || '#1CAEFF',
          // primarySolidHover: primaryVariants?.[3] || '#0074DD',
          // primaryText: primaryVariants?.[3] || '#0074DD',
          // // Update other dynamic values
          // inputBorder: backgroundVariants?.[7] || '#D0D5DD',
        },
      }),
    // Add an inline comment to explain the necessity of these dependencies
    []
  )

  return (
    <StyledThemeProvider className={dynamicTheme.className}>
      {children}
    </StyledThemeProvider>
  )
}

export default DynamicThemeProvider
